import { Component, input } from '@angular/core';

@Component({
  selector: 'app-data-not-found',
  standalone: true,
  imports: [],
  templateUrl: './data-not-found.component.html',
  styleUrl: './data-not-found.component.scss',
})
export class DataNotFoundComponent {
  field = input.required<string>();
}
